package one.healthium.ui.compose.theme.styles

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black30
import one.healthium.ui.compose.theme.orange_3
import one.healthium.ui.compose.theme.pink_3
import one.healthium.ui.compose.theme.yellow_2

data class ProfileStyle(
    val cardShape: Shape? = null,
    val weightProgressBarStyle: ChartStyle? = null,
    val weightProgressChartStyle: ChartStyle = ChartStyle(
        barColor = yellow_2,
        highlightedBarColor = orange_3,
    ),
    val caloriesChartStyle: ChartStyle = ChartStyle(
        barColor = pink_3,
        highlightedBarColor = orange_3,
    ),
    val settingButtonTint: Color? = null,
    private val avatarContainerColor: Color? = null,
    private val avatarContentColor: Color? = null,
) {
    val cardShapeOrDefault: Shape
        @Composable get() = cardShape ?: AppTheme.shapes.medium

    val settingButtonTintOrDefault: Color
        @Composable get() = settingButtonTint ?: black30

    val avatarContainerColorOrDefault: Color
        @Composable get() = avatarContainerColor ?: AppTheme.colors.primary

    val avatarContentColorOrDefault: Color
        @Composable get() = avatarContentColor ?: AppTheme.colors.onPrimary
}

data class ChartStyle(
    val barColor: Color,
    val highlightedBarColor: Color,
    val barShape: Shape? = null,
    val cardShape: Shape? = null,
) {
    val barShapeOrDefault: Shape
        @Composable get() = barShape ?: AppTheme.shapes.medium

    val cardShapeOrDefault: Shape
        @Composable get() = cardShape ?: AppTheme.shapes.large
}
